/*** IMPORTS FROM imports-loader ***/
import Translator from "bazinga-translator";

(function (t) {
// ru
t.add("cart.tickets.no_available_tickets_for_seating", "\u041d\u0430 \u0432\u044b\u0431\u0440\u0430\u043d\u043d\u044b\u0435 \u043c\u0435\u0441\u0442\u0430 \u043d\u0435\u0442 \u0431\u0438\u043b\u0435\u0442\u043e\u0432", "PayseraCartBundle", "ru");
t.add("cart.tickets.no_available_tickets", "\u041d\u0435\u0442 \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u044b\u0445 \u0431\u0438\u043b\u0435\u0442\u043e\u0432", "PayseraCartBundle", "ru");
t.add("paysera_cart.discount.invalid_code", "\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0441\u043a\u0438\u0434\u043a\u0438", "PayseraCartBundle", "ru");
})(Translator);
